<template>
  <div class="ui container">
    <form @submit.prevent="bookNow" class="ui form">
      <div
        v-show="stepProcess == 1"
        class="ui two column stackable grid segment padded"
        style=""
      >
        <!-- Seccion  fecha reserva y Jugadores -->
        <div class="ui six wide column">
          <h2 class="ui dividing header">Top Tracer</h2>
          <div class="column">
            <h4 class="ui dividing header">
              1. Seleccione jugadores & número de hoyos
            </h4>
            <div class="field" v-show="false">
              <sui-form-fields inline>
                <sui-form-field>
                  <sui-checkbox
                    v-model="playersNumber"
                    @onChange="changeHoyos"
                    radio
                    checked="true"
                    name="second_fruit"
                    label="1 Player"
                    value="1"
                  />
                </sui-form-field>
                <sui-form-field>
                  <sui-checkbox
                    v-model="playersNumber"
                    @onChange="changeHoyos"
                    radio
                    name="second_fruit"
                    label="2 Players"
                    value="2"
                  />
                </sui-form-field>
                <sui-form-field>
                  <sui-checkbox
                    v-model="playersNumber"
                    @onChange="changeHoyos"
                    radio
                    name="second_fruit"
                    label="3 Players"
                    value="3"
                  />
                </sui-form-field>
                <sui-form-field>
                  <sui-checkbox
                    v-model="playersNumber"
                    @onChange="changeHoyos"
                    radio
                    name="second_fruit"
                    label="4 Players"
                    value="4"
                  />
                </sui-form-field>
              </sui-form-fields>
              <customSelect
                v-show="false"
                v-model="playersNumber"
                @onChange="changePlayersNumber"
                :data="comboPlayers"
              ></customSelect>
            </div>
            <div class="field">
              <div class="eight ui buttons">
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '1' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '1';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  1
                </button>
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '2' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '2';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  2
                </button>
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '3' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '3';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  3
                </button>
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '4' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '4';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  4
                </button>
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '5' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '5';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  5
                </button>
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '6' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '6';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  6
                </button>
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '7' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '7';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  7
                </button>
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '8' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '8';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  8
                </button>
              </div>
            </div>
            <div v-show="false" class="field">
              <selectTipoJuego
                :TOPTRACER="true"
                v-model="hoyos"
                @onChange="changeHoyos"
              ></selectTipoJuego>
            </div>
            <h4 class="ui dividing header">2. Selecciona una fecha</h4>
            <div class="field">
              <datepicker
                @selected="selectDate"
                :inline="true"
                :value="input_date.format('MM/DD/YYYY')"
                :disabled-dates="disabledDates"
                :highlighted="highlighted"
              ></datepicker>
            </div>
            <div class="ui card fluid">
              <div class="content">
                <div class="header">Información de la reserva:</div>
              </div>
              <div class="content">
                <div class="ui bulleted list">
                  <!--<div class="item">Green Fee</div>-->
                  <!--<div class="item">Shared Golf cart</div>-->
                  <div class="item">Unlimited balls and Golf club</div>

                  <!--<div class="item">A bottle of water p/p</div>-->
                </div>
                <div class="ui bulleted list">
                  <template v-for="(tarifaData, index) in listadoTarifas">
                    <div class="item" :key="index">
                      {{ tarifaData.text }}:
                      <div class="ui bulleted list">
                        <template
                          v-for="(modData, indexMod) in tarifaData.data
                            .arrayPrecios"
                        >
                          <div class="item" :key="tarifaData.value + indexMod">
                            {{ modData.data.nombre }}:
                            <div class="ui bulleted list">
                              <template
                                v-for="(
                                  modHorario, indexHor
                                ) in modData.horarios"
                              >
                                <div
                                  class="item"
                                  :key="tarifaData.value + indexMod + indexHor"
                                >
                                  {{ modHorario.data.Nombre }}:{{
                                    modHorario.PcoVen
                                  }}
                                  {{ modHorario.Moneda }}
                                </div>
                              </template>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end Seccion  fecha reserva y Jugadores -->
        <div class="ui ten wide column">
          <div class="column">
            <div class="fields two">
              <div class="field">
                <model-select
                  :options="tarifaCombo"
                  v-model="tarifario"
                  class="use-keyboard-input"
                  @input="getTarifasByTarifario()"
                  placeholder="Seleccione un tarifario"
                >
                </model-select>
              </div>
              <div class="field">
                <model-select
                  :options="listadoTarifas"
                  v-model="tarifa"
                  class="use-keyboard-input"
                  @input="getTarifas()"
                  placeholder="Seleccione una Tarifa"
                >
                </model-select>
              </div>
            </div>
            <!-- Seccion  tipo de pago si es hotel -->
            <div v-if="isHotel" class="field">
              <h4 class="ui dividing header">3. Selecciona una tarifa</h4>
              <div class="ui buttons" style="width: 100%">
                <button
                  v-bind:class="{ green: typePaid == 1, blue: typePaid != 1 }"
                  class="ui button"
                  type="button"
                  @click="selectPaid(1)"
                >
                  <b>GOLF INCLUDED</b>
                  <br />
                  <p class="paidDescription">
                    Golf included in hotel reservation
                  </p>
                </button>
                <div class="or"></div>
                <button
                  v-bind:class="{ green: typePaid === 2, blue: typePaid !== 2 }"
                  class="ui button"
                  type="button"
                  @click="selectPaid(2)"
                >
                  GUEST PAID
                  <br />
                  <p class="paidDescription">Golf fee paid by the customer</p>
                </button>
              </div>
            </div>
            <!-- end Seccion  tipo de pago si es hotel -->
            <!-- Seccion  codigo Promocional -->
            <div v-if="typePaid === 1">
              <h4 class="ui dividing header">
                4. Codigo promocional
                <div
                  v-if="errors.code"
                  class="ui left pointing red basic label"
                >
                  El codigo promocional es requerido
                </div>
                <!--<template v-if="errors.code">
                                        <span  class="unavailable" style="color:red;">Promotional code is required </span>
                                </template> -->
              </h4>
              <div class="field">
                <input
                  type="text"
                  v-model="promotionalCode"
                  name="promotional"
                  placeholder="Promotional code"
                />
              </div>
            </div>
            <!-- end Seccion  codigo Promocional -->
            <!-- Seccion horarios -->
            <h4 class="ui dividing header">
              {{ computedStep.stepTime }}. Selecciona el horario de juego
              <b v-if="isHotel">
                {{
                  typePaid === 1
                    ? "- (GOLF INCLUDED)"
                    : typePaid === 2
                    ? " - (GUEST PAID)"
                    : ""
                }}
              </b>
            </h4>
            <div v-if="false">
              <template v-if="typePaid > 0 || !isHotel">
                <!--<div  v-if="isHotel" class="ui row">
                                <div style="float:right;">
                                    <sui-checkbox label="Prefered" toggle @change="showPrefered" v-model="prefered"/>  
                                </div>
                            </div>-->

                <!--
                            <div v-if="tarifas.length >= 1" >
                                <vue-tabs :key="compIndex" >
                                    <template   v-for="(tarifa,index) in tarifas">
                                        <v-tab  :title="tarifa.Horario.Nombre" :key="index">
                                            <a style="    background: rgba(0,181,173,.37)!important; color:white; margin-bottom: 2%;" class="ui  label"> !</a> Prefered Time for Transportation
                                            <div class="ui six doubling cards">
                                                <template v-for="(time,index) in times">
                                                        <timeCard 
                                                            v-if="time.tarifaId == tarifa.id"
                                                            v-bind:class="{ cardActive: (index === selectedPriceIndex) }" 
                                                            :time="time.time" 
                                                            :price="time.precio" 
                                                            :priceGlobal="time.precioGlobal"
                                                            :prefered="time.preferedClass"
                                                            :players="playersNumber"
                                                            :reservados="time.personas" 
                                                            :tarifaId="time.tarifaId"
                                                            :privado="time.privado"
                                                            :isAdmin="isAdmin"
                                                            :selectedDate="input_date"
                                                            :key="index"
                                                            @clicked="setSelectedTime"
                                                        >
                                                        </timeCard> 
                                                </template>
                                            </div>
                                        </v-tab> 
                                    </template>
                                </vue-tabs> 
                            </div>
                            -->
              </template>
            </div>
            <template v-if="typePaid > 0 || !isHotel">
              <!--<div  v-if="isHotel" class="ui row">
                                <div style="float:right;">
                                    <sui-checkbox label="Prefered" toggle @change="showPrefered" v-model="prefered"/>  
                                </div>
                            </div>-->

              <div v-if="compTarifas.length >= 1">
                <p>Elija una bahia para seleccionar un rango de tiempo</p>
                <div class="field">
                  <sui-checkbox :label="'Ver todo'" toggle v-model="showAll" />
                </div>

                <timeTopTracer
                  :reservasData="reservas"
                  :showAll="showAll"
                  :selectedDate="input_date"
                  :key="topTracerTee"
                  @cleanTimesRange="cleanTimesRange"
                  @selectTimesRange="selectTimesRange"
                  :times="times"
                ></timeTopTracer>
                <div class="field" v-if="rangeSelected !== false">
                  <button
                    type="button"
                    @click="stepProcess = 2"
                    class="ui fluid green button"
                  >
                    Siguiente
                  </button>
                </div>
              </div>
            </template>
            <!-- end Seccion horarios -->
          </div>
        </div>
      </div>
      <!-- end Seccion de datos fecha reserva -->

      <!-- Seccion de datos del cliente -->
      <div
        v-show="this.stepProcess == 2"
        class="ui column stackable grid segment padded"
      >
        <div class="ui four wide column centered">
          <div class="ui two buttons" style="margin-bottom: 10px">
            <div class="ui basic green button" @click="resetSelect">
              <i class="reply icon"></i> Regresar
            </div>
            <!---->
          </div>
          <resume
            :playersNumber="playersNumber"
            :selectedTime="
              rangeSelected != false
                ? rangeSelected[0].time + ' - ' + rangeSelected[1].time
                : ''
            "
            :date="input_date"
          ></resume>
        </div>
        <div id="dataClient" class="ui twelve wide column centered">
          <h3 class="ui header">
            {{ computedStep.stepExtraInfo }}. Información de los jugadores
            <div v-if="errors.players" class="ui left pointing red basic label">
              Completa la informacion de los jugadores
            </div>
            <!--<template v-if="errors.players">
                                <span  class="unavailable" style="color:red;">Fill players information </span>
                            </template> -->
          </h3>
          <div class="ui one cards">
            <template v-for="(player, index) in players">
              <div
                v-if="index == 0"
                :key="index"
                class="card fluid"
                v-show="!editPlayers.edit || editPlayers.playerIdx == index"
              >
                <div class="content">
                  <div class="header">
                    Jugador {{ index + 1 }} -
                    {{
                      player.name == ""
                        ? "Complete la información del jugador"
                        : player.name
                    }}
                  </div>
                  <div class="meta"></div>
                  <div class="description">
                    <div class="ui list">
                      <div class="item">
                        <i class="mail icon"></i>
                        <div class="content">
                          {{
                            player.email == ""
                              ? "Información del correo requerida"
                              : player.email
                          }}
                        </div>
                      </div>
                      <div class="item">
                        <i class="phone icon"></i>
                        <div class="content">
                          {{
                            player.phone == ""
                              ? "Numero telefonico (opcional)"
                              : player.phone
                          }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-show="
                        editPlayers.edit && editPlayers.playerIdx == index
                      "
                      class="field"
                      v-bind:key="index"
                    >
                      <h4 class="ui dividing header">Player {{ index + 1 }}</h4>

                      <div v-if="false" class="field">
                        <sui-checkbox
                          :label="'Seleccionar del listado de clientes'"
                          toggle
                          v-model="player.isClient"
                        />
                      </div>
                      <div v-if="player.isClient" class="field">
                        <Select2
                          v-model="player.IdCliente"
                          :options="comp_clients"
                          @change="setPlayerData(player)"
                        />
                        <button
                          type="button"
                          style="margin-top: 5px"
                          @click="showModalCliente = true"
                          class="ui primary tiny button"
                        >
                          Agregar Cliente
                        </button>
                      </div>
                      <div class="field">
                        <input
                          type="text"
                          :readonly="player.isClient"
                          v-model="player.name"
                          name="name"
                          placeholder="Name"
                        />
                      </div>
                      <div class="field">
                        <input
                          type="email"
                          :readonly="player.isClient"
                          v-model="player.email"
                          name="mail"
                          placeholder="Email"
                        />
                      </div>
                      <div class="field">
                        <input
                          type="number"
                          v-model="player.phone"
                          name="number"
                          placeholder="Phone Number (Optional)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="extra content">
                  <div class="ui two buttons">
                    <div
                      v-if="!editPlayers.edit"
                      class="ui basic green button"
                      @click="editPlayer(index)"
                    >
                      Editar
                    </div>
                    <div
                      v-if="editPlayers.edit"
                      class="ui basic green button"
                      @click="editPlayer(index)"
                    >
                      Guardar
                    </div>
                    <div
                      v-if="index != 0 && !editPlayers.edit"
                      class="ui basic red button"
                      @click="deletePlayer(index)"
                    >
                      Eliminar
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <h4 class="ui dividing header"></h4>
          <div class="field" style="margin-top: 10px">
            <textarea
              type="text"
              v-model="nota"
              name="mail"
              placeholder="Notas de la reserva"
            ></textarea>
          </div>
          <div class="field">
            <transition name="slide-fade">
              <h1 style="float: right">
                Total USD:${{ Totales.totalUSD }} USD <br />
                Total {{$Currencies.getCurrencyDefault()}}:${{ Totales.totalMXN }} {{$Currencies.getCurrencyDefault()}}
              </h1>
            </transition>
          </div>
          <div class="field">
            <button v-if="loadingData == false" class="ui fluid green button">
              Reservar Ahora
            </button>
          </div>
        </div>
      </div>
      <!-- End Seccion de datos del cliente -->
      <!--<div class="big ui right aligned primary button full-button" @click="$router.push({path:'/proshop/menu'})" style="float: right; margin-top: 10px;"><i class="reply icon" ></i>Regresar </div>-->

      <!-- Modal extra rider -->
      <sui-modal v-model="modalOpen" size="small">
        <sui-modal-header>Add Cart Riders to reservation</sui-modal-header>
        <sui-modal-content scrolling>
          <sui-modal-description>
            <div class="field">
              <div class="ui action input">
                <input
                  type="text"
                  v-model="cartRiderName"
                  placeholder="Cart Rider Name "
                />
                <button type="button" @click="addCartRider" class="ui button">
                  Add +{{ addOn.cartRider.Precio }} {{ addOn.cartRider.Moneda }}
                </button>
              </div>
            </div>
            <div class="ui relaxed divided list">
              <template v-for="(cartRider, index) in cartRiders">
                <div class="item" :key="index">
                  <i class="large user middle aligned icon"></i>
                  <div class="content">
                    <div class="header">{{ cartRider.name }}</div>
                    <div class="description">
                      ${{ addOn.cartRider.Precio }}
                      <a
                        style="float: right"
                        @click="deleteCartRider(index)"
                        href="javascript:void(0);"
                        class="aligned"
                        ><i class="large close middle aligned icon"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </sui-modal-description>
        </sui-modal-content>
        <sui-modal-actions>
          <button type="button" @click="toggleModal" class="ui button positive">
            OK
          </button>
        </sui-modal-actions>
      </sui-modal>
      <!-- end Modal extra rider -->
    </form>

    <modal v-model="confirmBook" :showFooter="false" title="Reserva Guardada">
      <p>La reserva se guardo correctamente, ¿Cómo deseas continuar?</p>
      <div>
        <button
          @click="$router.push({ path: '/proshop/sales-point' })"
          class="ui right floated green button"
        >
          Ir a Punto de Venta
        </button>

        <button
          @click="confirmBook = false"
          class="ui right floated secondary basic button"
        >
          Nueva Reserva
        </button>

        <button
          @click="$router.push({ path: '/proshop/menu' })"
          class="ui right floated right primary basic button"
        >
          Ir a Menu
        </button>
      </div>
    </modal>
    <modal
      v-model="transModal"
      :showFooter="false"
      title="Reservar Transportación"
    >
      <transportacion
        :key="tranindx"
        :paxNumber="this.players.length + this.cartRiders.length"
        :prefered="this.isPreferedTime"
        :fecha="this.input_date.format('YYYY-MM-DD')"
        :time="this.selectedTime"
        @setData="setTransData"
      >
      </transportacion>
    </modal>

    <modal
      v-model="showModalCliente"
      :showFooter="false"
      title="Agregar Cliente"
    >
      <h3>Proporcione los datos del cliente</h3>
      <div class="ui form">
        <div class="field">
          <label>Nombre</label>
          <div class="two fields">
            <div class="field">
              <input
                type="text"
                name="nombre"
                v-model="clientAdd.nombre"
                placeholder="Nombres"
              />
            </div>
            <div class="field">
              <input
                type="text"
                name="apellidos"
                v-model="clientAdd.apellidos"
                placeholder="Apellidos"
              />
            </div>
          </div>
        </div>
        <div class="field">
          <label>Correo</label>
          <input
            type="text"
            name="correo"
            v-model="clientAdd.correo"
            placeholder="Correo electronico"
          />
        </div>
        <div class="field">
          <label>Telefono</label>
          <input
            type="text"
            name="nombre"
            v-model="clientAdd.telefono"
            placeholder="Telefono"
          />
        </div>
        <div class="field">
          <button @click="showModalCliente = false" class="ui big red button">
            Cancelar
          </button>
          <button @click="createClient()" class="ui big green button">
            Agregar Cliente
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<style >
@media only screen and (max-width: 600px) {
  .paidDescription {
    display: none !important;
  }
}

.vdp-datepicker__calendar {
  width: 100% !important;
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (max-width: 768px) {
  .paidDescription {
    display: none !important;
  }
}
</style>


<script>
//const $ = require('jquery');
//window.$ = $;

import moment from "moment";
import transportacion from "../../MainComponents/Transportacion.vue";
import Datepicker from "vuejs-datepicker";
import timeTopTracer from "../../MainComponents/timeListTopTracer.vue";
import resume from "../../Reservas/reservationResume.vue";
import selectTipoJuego from "../../MainComponents/selectTipoJuego.vue";
import customSelect from "../../MainComponents/customSelect.vue";
import TarifasClass from "../../../clases/Tarifa.js";
import modal from "../../MainComponents/modal.vue";
import Select2 from "v-select2-component";
import "../../../assets/css/custom.css";
import "../../../assets/css/listTeeSheet.css";
import "../../../assets/css/sideBar.css";
import { ModelSelect } from "vue-search-select";
import Reserva from "../../../clases/Reserva.js";
import ReservaClass from "../../../clases/Reserva.js"

export default {
  name: "ReservaTopTracerAfiliado",
  components: {
    Datepicker,
    ModelSelect,
    selectTipoJuego,
    customSelect,
    resume,
    transportacion,
    modal,
    Select2,

    timeTopTracer,
  },
  data() {
    return {
      stepProcess: 1,
      MainDepartamento: "",
      rangeSelected: false,
      tarifario: "",
      tarifa: "",
      Totales: {},
      topTracerTee: 1,

      listadoTarifas: [],
      Horarios: [],
      subcategorias: [],
      clientAdd: { nombre: "", apellidos: "", correo: "", telefono: "" },
      showModalCliente: false,
      nota: "",
      totalReservas: 0,
      totalPlayers: 0,
      showAll: false,
      data_clientes: [],
      index_hotel: "",
      hoteles: [],
      confirmBook: false,
      transModal: false,
      input_date: moment(),
      actualDate: moment(),
      editPlayers: {
        edit: false,
        playerIdx: "",
      },
      roomNumber: "",
      tranindx: 1,
      isAdmin: false,
      transportation: false,
      loadingData: false,
      private_reservation: false,
      isPreferedTime: false,
      Session: "",
      ApiToken: "",
      TotalTrans: 0,
      RowId: "",
      DuracionViaje: "",
      rawDuracionViaje: "",
      HtlPickup: "",
      PCGCPickup: "",
      checkAsGuest: false,
      promotionalCode: "",
      selectedTarifa: "",
      compIndex: 0,
      actualListener: "",
      prefered: true,
      RsvaTransId: "",
      forceRecomputeCounter: 0,
      // Confirm:"",
      modalOpen: false,
      selectedPriceIndex: "",
      selectedTime: "",
      playersNumber: 1,
      cartRiderName: "",
      addOn: { cartRider: "", golfClub: "", transport: "" },
      hoyos: "",
      players: [
        {
          name: "",
          email: "",
          phone: "",
          golfClub: false,
          side: "right",
          genero: "Man",
          shaft: "regular",
          tarifa: "",
          isClient: false,
          IdCliente: " ",
        },
      ],
      tiposJuego: [],
      temporadas: [],
      tarifas: [],
      tarifaGlobal: [],
      AllTarifas: [],
      times: [],
      reservas: [],
      cartRiders: [],
      daysRules: [],
      comboPlayers: [
        { value: "1", text: "1 Player" },
        { value: "2", text: "2 Player" },
        { value: "3", text: "3 Player" },
        { value: "4", text: "4 Player" },
      ],
      tarifaCombo: [],
      initTime: new moment("06:00", "HH:mm"),
      endTime: new moment("22:00", "HH:mm"),
      startHour: "06:00:00",
      endHour: "22:00:00",
      configTime: {},
      intervalo: 10,
      errors: {
        time: false,
        players: false,
        code: false,
      },
      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(moment()),
          //new Date(2020, 0, 17),
          //new Date(2020, 0, 18)
        ],
      },
    };
  },
  props: ["isHotel", "isWeb", "hideMenu"],
  methods: {
    cleanTimesRange() {
      this.stepProcess = 1;
      this.rangeSelected = false;
    },
    selectTimesRange(times) {
      this.rangeSelected = times;
      let initTim = new moment(times[0].time, "HH:mm");
      let endTime = new moment(times[1].time, "HH:mm");
      let auxDate = initTim;
      let timesData = [];

      var i;
      /*para cada uno de los horarios armados se asignan los datos necesarios*/
      for (i = 0; auxDate.format("HH:mm") < endTime.format("HH:mm"); i++) {
        let intervalo = 30;
        let horarioTime = "";

        this.tarifas.forEach((tarifa) => {
          tarifa.arrayPrecios.forEach((modalidad) => {
            modalidad.horarios.forEach((horario) => {
              let endCompTime = new moment(
                auxDate.format("HH:mm:ss"),
                "HH:mm:ss"
              ).add(intervalo, "minutes");
              if (
                horario.data.HoraInicio <= auxDate.format("HH:mm:ss") &&
                horario.data.HoraTermino >= endCompTime.format("HH:mm:ss")
              ) {
                horarioTime = horario.id;
              }
            });
          });
        });

        let timeData = {
          horarioTime: horarioTime,
          time: auxDate.format("HH:mm"),
        };
        auxDate = auxDate.add(intervalo, "minutes");
        (timeData.timeEnd = auxDate.format("HH:mm")), timesData.push(timeData);
      }
      let HorariosTimeData = [];
      timesData.forEach((time) => {
        if (
          this.$pgsHelper.getById(HorariosTimeData, "horario", time.horarioTime)
        ) {
          HorariosTimeData[
            this.$pgsHelper.getById(
              HorariosTimeData,
              "horario",
              time.horarioTime
            ).idx
          ].times.push(time);
        } else {
          HorariosTimeData.push({
            horario: time.horarioTime,
            times: [time],
          });
        }
      });

      let totalUSD = 0;
      let totalMXN = 0;

      HorariosTimeData.forEach((horario) => {
        horario.times.length;

        let Horas = 0;
        let MediasHoras = 0;

        Horas = Math.floor(horario.times.length / 2);
        MediasHoras = horario.times.length - Horas * 2;

        horario.Horas = Horas;
        horario.MediasHoras = MediasHoras;

        horario.HorasPrecio = 0;

        horario.MediasHorasPrecio = 0;

        let hModalidad = this.$pgsHelper.getById(
          this.tarifaPrice,
          "id",
          "01HOR"
        );
        let mModalidad = this.$pgsHelper.getById(
          this.tarifaPrice,
          "id",
          "30MIN"
        );

        let hPrecio = this.$pgsHelper.getById(
          hModalidad.Horarios,
          "id",
          horario.horario
        );

        let mPrecio = this.$pgsHelper.getById(
          mModalidad.Horarios,
          "id",
          horario.horario
        );

        horario.HorasPrecio = Horas * hPrecio.PcoVen;
        horario.HorasPrecioMoneda = hPrecio.Moneda;
        horario.MediasHorasPrecio = MediasHoras * mPrecio.PcoVen;
        horario.MediasHorasMoneda = hPrecio.Moneda;
        let cambio = this.tiposCambio.TC.USD;
        if (horario.HorasPrecioMoneda == this.$Currencies.getCurrencyDefault()) {
          totalUSD += Math.ceil(horario.HorasPrecio / cambio);
          totalMXN += horario.HorasPrecio;
        } else if (horario.HorasPrecioMoneda == "USD") {
          totalUSD += horario.HorasPrecio;
          totalMXN += parseFloat(horario.HorasPrecio * cambio);
        }

        if (horario.MediasHorasMoneda == this.$Currencies.getCurrencyDefault()) {
          totalUSD += Math.ceil(horario.MediasHorasPrecio / cambio);
          totalMXN += horario.MediasHorasPrecio;
        } else if (horario.MediasHorasMoneda == "USD") {
          totalUSD += horario.MediasHorasPrecio;
          totalMXN += parseFloat(horario.MediasHorasPrecio * cambio);
        }

        this.Totales = {
          totalUSD: totalUSD,
          totalMXN: totalMXN,
        };

        if (this.typePaid === 1) {
          this.Totales = {
            totalUSD: 0,
            totalMXN: 0,
          };
        }
      });

      
      
    },
    async init() {
      await this.getTemporadas();

      await this.getTiposJuego();
      await this.getSubcategoria();
      await this.getHorarios();
      await this.getTarifasCombo();
      this.getAddons();
      this.getDaysRules();

      this.getHoteles();
    },
    async getTarifasByTarifario() {
      let idTemporada = "";
      this.temporadas.forEach((element) => {
        if (
          moment(element.FechaInicio).format("YYYY-MM-DD") <=
            this.input_date.format("YYYY-MM-DD") &&
          moment(element.FechaTermino).format("YYYY-MM-DD") >=
            this.input_date.format("YYYY-MM-DD")
        ) {
          idTemporada = element.id;
        }
      });

      let TarifasCombo = [];
      let tarifas = await TarifasClass.getMixTarifasByTarifarioParse(
        this.tarifario,
        idTemporada,
        this.MainDepartamento,
        this.Horarios,
        this.temporadas,
        this.tiposJuego,
        this.input_date.day()
      );
      tarifas.forEach((tarifa, index) => {
        let nameTarifa = "Tarifa: ";
        let categoriaId = null;
        let categoriaName = null;
        tarifa.Subcategoria.forEach((element) => {
          categoriaId = element;
          nameTarifa +=
            this.$pgsHelper.getById(this.subcategorias, "id", element).Nombre +
            " ";
          categoriaName = this.$pgsHelper.getById(
            this.subcategorias,
            "id",
            element
          ).Nombre;
        });
        TarifasCombo.push({
          value: tarifa.id,
          text: nameTarifa,
          data: tarifa,
          cateTarifa: {
            id: categoriaId,
            nombre: categoriaName,
          },
        });
      });

      this.listadoTarifas = TarifasCombo;
    },
    async getSubcategoria() {
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Tarifas/" + this.MainDepartamento + "/SubCategorias")
        .once("value");
      if (!data.exists()) {
        return false;
      }
      let arrayHoteles = Object.entries(data.val());

      arrayHoteles.forEach((element) => {
        this.$pgsHelper.log(element);
        this.subcategorias.push({
          id: element[0],
          key: element[0],
          text: element[1].Nombre,
          value: element[0],
          ...element[1],
        });
      });
    },
    async getHorarios() {
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Tarifas/" + this.MainDepartamento + "/Horarios")
        .once("value");

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    async getTarifasCombo() {
      let tarifarios = await TarifasClass.getMixTarifasComboByAcceso(
        this.MainDepartamento,
        this.mayoristaData.id
      );
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifaCombo = tarifarios;
    },
    createClient() {
      if (!this.validateClientForm()) {
        this.$swal({
          icon: "error",
          title: "Proporcione nombre, apellidos y correo del cliente",
          text: "Complete los campos faltantes",
        });
        return false;
      }

      this.$swal({
        title: "¿Deseas guardar la información del cliente?",
        text: "El cliente se guardara y se vinculara al jugador seleccionado",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar!",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = {
            Nombres: this.clientAdd.nombre.replace(/^\s\s*/, '').replace(/\s\s*$/, ''),
            Apellidos: this.clientAdd.apellidos.replace(/^\s\s*/, '').replace(/\s\s*$/, ''),
            Correo: this.clientAdd.correo,
            Telefonos: [this.clientAdd.telefono],
            Telefono: this.clientAdd.telefono,
          };
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Clientes-createCliente", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              allowOutsideClick: false,
              title: "Guardado",
              text: "El cliente se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.showModalCliente = false;
              this.getClientes();
            });
          } else {
            this.$swal(
              "Error saving client",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    setPlayerData(player) {
      this.data_clientes.forEach((element) => {
        if (element.id == player.IdCliente) {
          player.name = element.Apellidos + " " + element.Nombres;
          player.email = element.Correo;
        }
      });
    },
    async getClientes() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder(
        "PDV_Clientes",
        [
          firestore.where("Tenant", "==", this.$store.getters.getFirebaseApp.tenant),
        ]
      );

      this.data_clientes = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Mayoristas/Coleccion")
        .on("value", (snapshot) => {
          this.hoteles = [];
          let arrayHoteles = Object.entries(snapshot.val());
          arrayHoteles.forEach((element) => {
            this.hoteles.push({ id: element[0], ...element[1] });
          });
        });
    },
    editPlayer(index) {
      this.editPlayers.edit = !this.editPlayers.edit;
      this.editPlayers.playerIdx = index;
    },
    deletePlayer(index) {
      this.players.splice(index, 1);
      this.playersNumber = this.players.length;
      this.forceRecomputeCounter++;
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    getTarifaData(id) {
      let itemIndex = this.$_.findIndex(this.tarifas, { Id: id });
      if (itemIndex >= 0) {
        this.tarifas[itemIndex].idxPlayers = [];
      }

      return this.tarifas[itemIndex];
    },
    addCartRider() {
      if (this.cartRiderName !== "") {
        this.cartRiders.push({ name: this.cartRiderName });
        this.cartRiderName = "";
        if (this.transportation) {
          this.getTransportationData();
        }
      } else {
        this.$swal({
          icon: "error",
          title: "Cart Rider Name is required",
          text: "",
        });
      }
    },
    deleteCartRider(index) {
      this.cartRiders.splice(index, 1);
      this.getTransportationData();
    },
    changePlayersNumber() {
      this.resetSelect();
      //this.players= [{name:'',email:'',phone:'',golfClub:false,side:"right",genero:'Man',shaft:'regular'}];
      if (this.players.length < this.playersNumber) {
        var i;
        for (i = this.players.length; i < this.playersNumber; i++) {
          this.players.push({
            name: "",
            email: "",
            phone: "",
            golfClub: false,
            side: "right",
            genero: "Man",
            shaft: "regular",
            tarifa: "",
            isClient: false,
            IdCliente: " ",
          });
        }
      } else if (this.players.length > this.playersNumber) {
        for (i = this.playersNumber; i < this.players.length; i) {
          this.players.pop();
        }
      }
      if (this.transportation) {
        this.getTransportationData();
      }
      this.forceRecomputeCounter++;
    },

    changeTrans(value) {
      //this.transportation = value;
      if (value == true) {
        this.transModal = true;
      } else {

      /*if(this.selectedPriceIndex === ""){
                this.$swal(
                    'Selecciona un horario',
                    'Selecciona un horario de juego antes de solicitar transportacion ',
                    'error'
                )

                document.getElementsByName('trans').forEach((element =>{
                    element.checked = false;
                }))
        }else if(this.transportation && this.selectedPriceIndex !== ""){
            if(this.isHotel){
                this.getTransportationData();
            }
            
        }*/
        this.Session = "";
        this.ApiToken = "";
        this.TotalTrans = 0;
        this.RowId = "";
        this.RsvaId = "";
        this.DuracionViaje = "";
        this.HtlPickup = "";
        this.PCGCPickup = "";
        //this.Confirm ="";
        this.transportation = value;
        this.tranindx++;
        this.$swal(
          "No se transportara a los jugadores",
          "La transportacion al campo de golf  no sera incluida en esta reserva ",
          "error"
        );
      }
    },
    changeHoyos() {
      this.resetSelect();
      (this.selectedTime = ""), (this.selectedPrice = ""), this.compIndex++;
      this.getTarifas();
    },
    changeAsGuest() {
      var $this = this;
      if (this.checkAsGuest == true) {
        var pNumber = 1;
        $this.players.forEach(function (element, index) {
          if (index != 0 && element.name == "") {
            element.name = "Guest " + pNumber;
            element.email = "guest@guestmail.com";
            pNumber++;
          }
        });
      } else {
        $this.players.forEach(function (element, index) {
          if (index != 0) {
            element.name = "";
            element.email = "";
          }
        });
      }
    },
    showPrefered() {
      this.resetSelect();
      if (this.prefered) {
        /* this.times.forEach((element)=>{
                   element.prefered = false;
           });*/
        this.times.forEach((element, index) => {
          if (element.personas > 0 && element.prefered == true) {
            this.times[index - 1].preferedClass = true;
            element.preferedClass = true;
            this.times[index + 1].preferedClass = true;
          }
        });
      } else if (this.prefered === false) {
        this.times.forEach((element) => {
          element.preferedClass = true;
        });
      }
    },
    setSelectedTime(key, time, idTarifa, prefered) {
      //alert(key + ' ' + time + ' ' + total);

      this.selectedPriceIndex = key;
      this.selectedTime = time;
      this.selectedTarifa = idTarifa;
      this.isPreferedTime = prefered;

      this.$nextTick(() => {
        document.getElementById("dataClient").scrollIntoView();
      });
    },
    selectDate(arg) {
      //let oldDate= this.input_date.format('YYYY-MM-DD');
      //this.killListener(oldDate);
      this.input_date = moment(arg);
      this.resetSelect();
      (this.selectedTime = ""),
        (this.selectedPrice = ""),
        (this.tarifario = ""),
        (this.listadoTarifas = []),
        this.getTarifasCombo();
      this.getTarifas();
    },
    setInitialDate() {
      this.input_date.format("YYYY-MM-DD");
      let aux = false;
      this.daysRules.forEach((element) => {
        if (element.data.Abre && element.data.Cierra) {
          if (this.input_date.format("YYYY-MM-DD") === element.date) {
            this.initTime = new moment(element.data.Abre, "HH:mm:ss");
            this.endTime = new moment(element.data.Cierra, "HH:mm:ss");
            aux = true;
          }
        }
      });
      if (!aux) {
        
        this.initTime = this.configTime.initTime;
        this.endTime = this.configTime.endTime;
      }
    },
    killListener(date) {
      this.$store.getters.getFirebaseApp.database.ref("Reservas/" + date).off();
    },
    selectPaid(value) {
      this.$store.commit("setTypePaid", value);
      this.getTarifas();
    },
    resetSelect() {
      this.stepProcess = 1;
      this.rangeSelected = false;
      this.topTracerTee++;
      this.selectedPriceIndex = "";
      this.isPreferedTime = false;
      document.getElementsByName("trans").forEach((element) => {
        element.checked = false;
      });
      this.$store.commit("setPriceSelected", 0);
    },

    async getTarifas() {
      let idTemporada = "";
      this.temporadas.forEach((element) => {
        if (
          moment(element.FechaInicio).format("YYYY-MM-DD") <=
            this.input_date.format("YYYY-MM-DD") &&
          moment(element.FechaTermino).format("YYYY-MM-DD") >=
            this.input_date.format("YYYY-MM-DD")
        ) {
          idTemporada = element.id;
        }
      });
      if (this.tarifa == "") {
        return false;
      }


      let tarifas = await TarifasClass.getMixTarifasByTarifarioParse(
        this.tarifario,
        idTemporada,
        this.MainDepartamento,
        this.Horarios,
        this.temporadas,
        this.tiposJuego,
        this.input_date.day()
      );

      this.tarifas = [this.$pgsHelper.getById(tarifas, "id", this.tarifa)];

      await this.getReservas();
      this.buildTimesData();
      this.loadingTarifas = false;
      this.$forceUpdate();
      this.forceRecomputeCounter++;
    },
    async getTarifasByPlayer(index) {
      let idTemporada = 0;
      let idTarifa = this.players[index].tarifa.id;

      /*  Ubica la temporada actual segun sus fechas de inicio y fin */
      this.temporadas.forEach((element) => {
        if (
          moment(element.FechaInicio).format("YYYY-MM-DD") <=
            this.input_date.format("YYYY-MM-DD") &&
          moment(element.FechaTermino).format("YYYY-MM-DD") >=
            this.input_date.format("YYYY-MM-DD")
        ) {
          idTemporada = element.id;
        }
      });

      let tarifas_array = [];
      let tarifas_parse = [];
      this.$pgsHelper.log(idTarifa);
      let global = await this.$store.getters.getFirebaseApp.firestore
        .doc("Golf_Tarifas/" + idTarifa + "/Temporadas/" + idTemporada)
        .get();
      let tarifa_global = { Id: global.ref.id, ...global.data() };
      tarifa_global.Accesos = "Global";

      tarifas_array.push(tarifa_global);

      var aux = 1;
      tarifas_array.forEach((element) => {
        let arrayHorarios = Object.entries(element.Horarios);
        arrayHorarios.forEach((horario) => {
          let arrayjuegos = Object.entries(horario[1].TiposJuego);
          arrayjuegos.forEach((juego) => {
            if (juego[0] == this.hoyos) {
              let tarifaObj = {};
              tarifaObj.Id = horario[0];
              tarifaObj.Precio = juego[1].Precio;
              tarifaObj.Moneda = juego[1].Moneda;
              tarifaObj.Horario = horario[1];
              tarifaObj.Accesos = [element.Accesos];
              tarifaObj.TarifaId = this.players[index].tarifa.id;
              tarifaObj.TarifaNombre = this.players[index].tarifa.text;
              tarifaObj.id = aux;

              if (element.Subcategoria) {
                tarifaObj.SubCategoria = element.Subcategoria;
              }

              aux++;
              tarifas_parse.push(tarifaObj);
            }
          });
        });
      });

      tarifas_parse.forEach((element, index) => {
        if (
          element.Horario.HoraTermino < this.actualDate.format("HH:mm:ss") &&
          this.actualDate.format("YYYY-MM-DD") ===
            this.input_date.format("YYYY-MM-DD")
        ) {
          element.pasado = true;
          tarifas_parse.splice(index, 1);
        }
      });
      /* ordena la tarifa por hora de inicio */
      tarifas_parse.sort(function compare(a, b) {
        return (
          moment(a.Horario.HoraInicio, "HH:mm") -
          moment(b.Horario.HoraInicio, "HH:mm")
        );
      });
      /*Asigna las tarifas globales y para hoteles o web*/
      this.players[index].Tarifas = [];
      let idHorarioTarifa = 0;
      this.tarifas.forEach((element) => {
        if (element.id === this.selectedTarifa) {
          idHorarioTarifa = element.Id;
        }
      });

      tarifas_parse.forEach((element) => {
        if (element.Id == idHorarioTarifa) {
          this.players[index].Tarifas = element;
        }
        if (
          element.Horario.HoraTermino >=
            moment(this.selectedTime, "HH:mm").format("HH:mm") &&
          element.Horario.HoraInicio <=
            moment(this.selectedTime, "HH:mm").format("HH:mm")
        ) {
          this.players[index].Tarifas = element;
        }
      });
      this.$pgsHelper.log(idHorarioTarifa);
      this.$pgsHelper.log(tarifas_parse);
      this.$pgsHelper.log(this.players);

      this.$forceUpdate();
      this.forceRecomputeCounter++;
    },
    getServicesIncludes() {},
    goRoute(routePath) {
      this.$router.push({ path: routePath });
    },
    async testRealTime() {
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("Configuracion/Reservas/EmailCCO")
        .once("value");
      this.$pgsHelper.log(data.val());
    },
    setTransData(data) {
      this.Session = data.Session;
      this.ApiToken = data.ApiToken;
      this.TotalTrans = data.TotalTrans;
      this.RowId = data.RowId;
      this.RsvaTransId = data.RsvaTransId;
      this.rawDuracionViaje = data.DuracionViaje;
      this.DuracionViaje = moment(data.DuracionViaje, "HH:mm:ss").format(
        "HH [Hrs] : mm [Min]."
      );
      if (data.typeTransportation == 1) {
        this.HtlPickup =
          data.HtlPickup.format(" DD-MMM-YYYY ") +
          moment(data.htime).format("HH [Hrs] : mm [Min].");
        this.PCGCPickup =
          data.PCGCPickup.format(" DD-MMM-YYYY ") +
          moment(data.gtime).format("HH [Hrs] : mm [Min].");
      } else if (data.typeTransportation == 2) {
        this.HtlPickup =
          data.HtlPickup.format(" DD-MMM-YYYY ") +
          moment(data.htime).format("HH [Hrs] : mm [Min].");
        this.PCGCPickup = "NA";
      } else if (data.typeTransportation == 3) {
        this.HtlPickup = "NA";
        this.PCGCPickup =
          data.PCGCPickup.format(" DD-MMM-YYYY ") +
          moment(data.gtime).format("HH [Hrs] : mm [Min].");
      }

      this.transportation = true;
      this.transModal = false;
    },
    async getTransportationData() {
      /* 
        Obiene la informacion de la transportacion para la reserva
        */
      let data = {
        PaxNumber: this.players.length + this.cartRiders.length,
        hotelCode: this.isHotel
          ? this.$route.params.user.tokenResult.claims.Code
          : this.index_hotel,
        Prefered: this.isPreferedTime,
        Fecha:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.selectedTime, "HH:mm").format("HH:mm:ss"),
      };
      this.loadingData = true;
      //var getTransportation = this.$store.getters.getFirebaseApp.fba.call('Golf-Reservas-transportationAvailability');
      return await this.$store.getters.getFirebaseApp.fba
        .call("Golf-Reservas-transportationAvailability", data, {})
        .then((result) => {
          this.Session = result.data.data.Session;
          this.ApiToken = result.data.data.ApiToken;
          this.TotalTrans =
            this.typePaid === 1
              ? this.playersNumber >= 4
                ? 0
                : this.addOn.transport.Precio
              : this.playersNumber >= 2
              ? 0
              : this.addOn.transport.Precio;
          this.RowId = result.data.data.RowId;
          this.RsvaTransId = result.data.data.RsvaTransId;
          this.rawDuracionViaje = result.data.data.DuracionViaje;
          this.DuracionViaje = moment(
            result.data.data.DuracionViaje,
            "HH:mm:ss"
          ).format("HH [Hrs] : mm [Min].");
          this.HtlPickup = moment(
            result.data.data.HtlPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format(" DD-MMM-YYYY HH:mm ");
          this.PCGCPickup = moment(
            result.data.data.PCGCPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format(" DD-MMM-YYYY HH:mm ");
          //this.Confirm= result.data.data.Confirm;
          this.loadingData = false;
        })
        .catch((error) => {
          this.$pgsHelper.log(error);
        });
    },
    async getTiposJuego() {
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Tarifas/" + this.MainDepartamento + "/Modalidades")
        .once("value");
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach(function (element) {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
        $this.hoyos = element[0];
      });
    },
    async getTemporadas() {
      /*
         Obtiene las temporadas existentes en la db
        */
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Tarifas/" + this.MainDepartamento + "/Temporadas")
        .once("value");
      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
         if(element[1].Activo){
          this.temporadas.push({ id: element[0], ...element[1] });
        }
      });
    },
    async getAddons() {

      let addons = this.$store.getters.getRVACatalogo;
      this.addOn.cartRider = addons.GOLFRIDDER;
      this.addOn.golfClub = addons.GOLFCLUB;
      this.addOn.transport = addons.TRANSPORT;
    },
    async getReservas() {
      /*
            Se obtiene las disponibilidad por dia y la cantidad de personas reservadas en esos dias
        */
      let date = this.input_date.format("YYYY-MM-DD");
      this.killListener(this.actualListener);
      this.$store.getters.getFirebaseApp.database
        .ref("RVA/Reservas/" + this.MainDepartamento + "/" + date)
        .on("value", (snapshot) => {
          if (snapshot.exists()) {
            this.reservas = [];

            let arrayReservas = snapshot.val();
            this.totalPlayers = 0;
            this.reservas = Reserva.parseAvailabilityDataTopTracer(
              arrayReservas
            );
          } else {
            this.reservas = [];
            this.totalPlayers = 0;
          }
          
          this.totalReservas = this.reservas.length;

          this.buildTimesData();
          this.showPrefered();
        });

      this.actualListener = date;
    },

    async getDaysRules() {
      this.$store.getters.getFirebaseApp.database
        .ref("RVA/Configuracion/" + this.MainDepartamento + "/Calendario")
        .on("value", (snapshot) => {
          if (snapshot.exists()) {
            this.daysRules = [];
            if (snapshot.val().Fechas_Especiales) {
              let arrayCalendar = Object.entries(
                snapshot.val().Fechas_Especiales
              );
              arrayCalendar.forEach((element) => {
                this.daysRules.push({ date: element[0], data: element[1] });
              });

              //ordena las reglas por fecha
              this.daysRules.sort(function compare(a, b) {
                return a.date - b.date;
              });
              //si la fecha inicial esta entre las reglas como un dia cerrado aumenta un dia
              this.daysRules.forEach((element) => {
                if (
                  element.date == this.input_date.format("YYYY-MM-DD") &&
                  element.data == false
                ) {
                  this.input_date.add(1, "days");
                }
              });
              // si es un lunes, verificar si en las reglas abre , si no aumentar un dia
              if (this.input_date.weekday() === 1) {
                let abre = false;
                this.daysRules.forEach((element) => {
                  if (
                    element.date == this.input_date.format("YYYY-MM-DD") &&
                    element.data == true
                  ) {
                    abre = true;
                  }
                });

                if (abre == false) {
                  this.input_date.add(1, "days");
                }
              }

              this.configTime.initTime = new moment(
                snapshot.val().Hora_Apertura,
                "HH:mm:ss"
              );
              this.configTime.endTime = new moment(
                snapshot.val().Hora_Cierre,
                "HH:mm:ss"
              );
            } else {
              if (this.input_date.weekday() === 1) {
                this.input_date.add(1, "days");
              }
              this.configTime.initTime = new moment(this.startHour, "HH:mm:ss");
              this.configTime.endTime = new moment(this.endHour, "HH:mm:ss");
              this.daysRules = [];
            }
          } else {
            this.daysRules = [];
          }

          this.getTarifas();
        });
    },
    buildTimesData() {
      /*
            Genera el array conteniendo cada horario disponible para reserva en un intervalo de 10 minutos desde la hora inicial y la hora final
        */
      this.initTime = "";
      this.endTime = "";
      this.setInitialDate();
      let initTim = new moment(this.initTime.format("HH:mm"), "HH:mm");
      let endTime = new moment(this.endTime.format("HH:mm"), "HH:mm");

      let auxDate = initTim;
      this.times = [];

      var i;
      /*para cada uno de los horarios armados se asignan los datos necesarios*/
      for (i = 0; auxDate.format("HH:mm") < endTime.format("HH:mm"); i++) {
        let intervalo = 30;
        var idTarifa;
        var precio;
        var idTarifaGlobal = "";
        var precioGlobal = "";
        let personas = 0;
        let privado = false;
        let prefered = false;
        let Moneda = "";
        /* Se asigna la tarifa y el precio */
        this.tarifas.forEach((tarifa) => {
          tarifa.arrayPrecios.forEach((modalidad) => {
            modalidad.horarios.forEach((horario) => {
              if (modalidad.id == this.hoyos) {
                if (
                  horario.data.HoraInicio <= auxDate.format("HH:mm:ss") &&
                  horario.data.HoraTermino >= auxDate.format("HH:mm:ss")
                ) {
                  idTarifa = horario.internalId;
                  precio = horario.PcoVen;
                  Moneda = horario.Moneda;
                }
              }
            });
          });
        });
        /*Se asigna la tarifa global y el precio global*/
        /*this.tarifaGlobal.forEach(tarifa => {
                tarifa.arrayPrecios.forEach(modalidad=>{
                    modalidad.horarios.forEach((horario)=>{
                        if(modalidad.id == this.hoyos){
                             if(horario.data.HoraInicio <= auxDate.format('HH:mm:ss') && horario.data.HoraTermino >= auxDate.format('HH:mm:ss')  ){
                                idTarifaGlobal = horario.internalId;
                                precioGlobal = horario.PcoVen;
                            }
                        }
                       
                    })
                })
            })*/
        let players = [];
        /*en caso de que tengan reservas en ese Horario y dia seleccionado se agregan a los datos*/
        this.reservas.forEach((element) => {
          let time = new moment(element.time, "HH:mm:ss");
          if (time.format("HH:mm") == auxDate.format("HH:mm")) {
            this.$pgsHelper.log(element);
            players = element.Players ? element.Players : [];
            personas = element.PAX;
            if (this.isHotel) {
              prefered = element.Prefered ? true : false;
            } else {
              prefered = false;
            }
            privado = element.Privado ? element.Privado : false;
          }
        });

        /* se agregan al array*/

        let timeData = {
          time: auxDate.format("HH:mm"),
          tarifaId: idTarifa,
          tarifaIdGlobal: idTarifaGlobal,
          precioGlobal: precioGlobal,
          precio: precio,
          personas: personas,
          privado: privado,
          players: players,
          prefered: prefered,
        };
        auxDate = auxDate.add(intervalo, "minutes");
        (timeData.timeEnd = auxDate.format("HH:mm")), this.times.push(timeData);
      }
    },
    validation() {
      var valid = true;

      if (this.selectedPriceIndex === "") {
        valid == false;
        this.errors.time = true;
      } else {
        this.errors.time = false;
      }
      let aux = 0;

      if (this.players[0].name == "" || this.players[0].email == "") {
        aux++;
      }

      if (aux > 0) {
        valid = false;
        this.errors.players = true;
      } else {
        this.errors.players = false;
      }

      if (this.typePaid === 1 && this.promotionalCode === "") {
        valid = false;
        this.errors.code = true;
      } else {
        this.errors.code = false;
      }
      this.$pgsHelper.log(this.transportation);
      if (this.transportation === "") {
        valid = false;
        this.errors.trans = true;
      } else {
        this.errors.trans = false;
      }

      return valid;
    },
    buildReservationData() {
      this.players.forEach((element, index) => {
        let tarifa = this.$pgsHelper.getById(
          this.listadoTarifas,
          "value",
          this.tarifa
        );

        this.players[index].TarifaSelected = {
          Tarifa: tarifa,
          Nombre: tarifa.text,
          TarifaId: tarifa.value,
        };
      });

      let resData = ReservaClass.buildRVAData({
        Tipo: "TopTracer",
        TimesData: this.dataTimes,
        Cliente: this.players[0],
        Players: [this.players[0]],
        Estatus: "Confirmed",
        Privado: false,
        FechaInicial:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.rangeSelected[0].time, "HH:mm").format("HH:mm:ss"),
        FechaFinal:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.rangeSelected[1].time, "HH:mm").format("HH:mm:ss"),
        Total: {
          total: this.Totales.totalUSD,
          totalPesos: this.Totales.totalMXN,
        },
        Prepagado: this.typePaid === 1 ? true : false,
        Notas: this.nota,
        Departamento: this.MainDepartamento,
        Tags: ["TOPTRACER"],
        Creador: this.isWeb ? "Web" : "ProShop",
        Modalidad: this.$pgsHelper.getById(this.tiposJuego, "id", this.hoyos),
        CartRiders: this.cartRiders,
        Addons: this.Addons,
        Bahia: this.rangeSelected[0].bay - 1,
        Invitados: this.players.length - 1,
        Transportacion: {
          TransTotal: parseFloat(this.TotalTrans),
          Session: this.Session,
          ApiToken: this.ApiToken,
          Prefered: this.isPreferedTime,
          RowId: this.RowId,
          DuracionViaje: this.rawDuracionViaje,
          RsvaTransId: this.RsvaTransId,
        },
      });

      return resData;
    },
    bookNow() {
      let validation = this.validation();
      if (validation) {
        let reservationData = this.buildReservationData();

        this.$swal({
          title: "¿Deseas generar esta reserva?",
          text:
            "Los datos de la reserva no podran ser modificados posteriormente",
          icon: "warning",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Reservar",
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            //var addReserva = this.$store.getters.getFirebaseApp.fba.call('RVA-Reservas-crearReserva');
            return await this.$store.getters.getFirebaseApp.fba
              .call("RVA-Reservas-crearReserva", reservationData)
              .then(function (result) {
                return result;
              })
              .catch((error) => {
                this.$swal.showValidationMessage(`Request failed: ${error}`);
              });
          },
        }).then((result) => {
          if (result.value) {
            if (result.value.data.ok) {
              let transReservation = "";
              if (result.value.data.data.Transportacion) {
                transReservation =
                  "Numero de transportación:" +
                  result.value.data.data.Transportacion.Confirmacion;
              }

              this.$swal({
                allowOutsideClick: false,
                title: "¡¡Reservado",
                text:
                  "Tu reservación se guardo correctamente, te enviamos un email con la información de la reserva. Reservación No. " +
                  result.value.data.data.Folio +
                  " " +
                  transReservation,
                icon: "success",
              }).then(() => {
                if (this.isWeb) {
                  location.href = "https://www.puertocancun.com";
                } else {
                  this.$emit("changeIndex");
                  if (process.env.IS_ELECTRON) {
                    this.confirmBook = true;
                  }
                }
              });

              //this.$emit('changeIndex');
            } else {
              this.$swal(
                "Error guardando la reserva",
                result.value.data.error,
                "error"
              );
            }
          }
        });
      }
    },
  },
  computed: {
    Addons() {
      /*
        Obtiene las temporadas existentes en la db
        */
      let AddOn = {};
      let addons = this.$store.getters.getRVACatalogo;
      AddOn.cartRider = addons.GOLFRIDDER; //arrayExt;
      AddOn.golfClub = addons.GOLFCLUB; //arrayGb;
      AddOn.transport = addons.TRANSPORT;
      AddOn.roundGolf = addons.GOLFROUND;
      return AddOn;
    },
    mayoristaData() {
      let mayoristas = this.$store.getters.getMayoristas;
      let mayoristaData = this.$pgsHelper.getById(
        mayoristas,
        "Codigo",
        this.$route.params.user.tokenResult.claims.Code
      );
      return mayoristaData;
    },
    tarifaPrice() {
      let preciosTarifa = [];
      this.tarifas.forEach((tarifa) => {
        tarifa.arrayPrecios.forEach((modalidad) => {
          let modalidadData = {
            id: modalidad.id,
            Nombre: modalidad.data.nombre,
            Horarios: [],
          };
          modalidad.horarios.forEach((horario) => {
            modalidadData.Horarios.push(horario);
          });
          preciosTarifa.push(modalidadData);
        });
      });
      return preciosTarifa;
    },
    typePaid() {
      return this.$store.getters.getTypePaid;
    },

    compTarifas() {
      let compTarifas = [];

      this.tarifas.forEach((tarifa) => {
        let HorarioAplicable = [];
        tarifa.arrayPrecios.forEach((modalidad) => {
          modalidad.horarios.forEach((horario) => {
            if (modalidad.id == this.hoyos) {
              if (this.showAll) {
                this.$pgsHelper.log("mostrar todos");
                HorarioAplicable.push(horario);
              } else {
                if (
                  moment(
                    this.input_date.format("YYYY-MM-DD") +
                      horario.data.HoraTermino,
                    "YYYY-MM-DD HH:mm:ss"
                  ).format("YYYY-MM-DD HH:mm:ss") >
                  this.actualDate.format("YYYY-MM-DD HH:mm:ss")
                ) {
                  HorarioAplicable.push(horario);
                }
              }
            }
          });
        });
        tarifa.HorariosVisibles = HorarioAplicable;
        compTarifas.push(tarifa);
      });
      return compTarifas;
    },
    comp_clients() {
      let clientes = [{ id: " ", text: "Seleccione un cliente" }];
      this.data_clientes.forEach((cli) => {
        clientes.push({ id: cli.id, text: cli.Apellidos + " " + cli.Nombres });
      });
      return clientes;
    },

    grandTotal() {
      /* calcula el total de la reserva, segun el tipo de pago y los items seleccionados */
      this.$pgsHelper.log(this.forceRecomputeCounter);
      let total = 0;

      this.players.forEach((element) => {
        total += element.Tarifas ? element.Tarifas.Precio : 0;
      });
      total += 0;
      total += parseInt(this.TotalTrans);

      this.players.forEach((element) => {
        if (element.golfClub) {
          total += this.addOn.golfClub.Precio;
        }
      });
      this.cartRiders.forEach(() => {
        total += this.addOn.cartRider.Precio;
      });

      return total;
    },
    computedStep() {
      let step = 3;
      let stepTrans = 4;
      let stepExtraInfo = 5;
      if (this.isHotel) {
        if (this.typePaid == 2) {
          step = 5;
          stepExtraInfo = 6;
        } else if (this.typePaid == 1) {
          step = 6;
          stepExtraInfo = 7;
        } else if (this.typePaid == "") {
          step = 5;
          stepExtraInfo = 6;
        }
      }

      return {
        stepTime: step,
        stepExtraInfo: stepExtraInfo,
        stepTrans: stepTrans,
      };
    },
    disabledDates() {
      let disable_dates = [];
      let open_dates = [];

      this.daysRules.forEach((element) => {
        if (element.data === false) {
          disable_dates.push(new Date(moment(element.date, "YYYY-MM-DD")));
        } else {
          open_dates.push(new Date(moment(element.date, "YYYY-MM-DD")));
        }
      });

      return {
        to: new Date(moment().subtract(1, "days")),
        dates: disable_dates,
        customPredictor: function (date) {
          let aux = true;
          let dateFormat =
            date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
          if (date.getDay() == 1) {
            open_dates.forEach((element) => {
              let openDate =
                element.getFullYear() +
                "-" +
                element.getMonth() +
                "-" +
                element.getDate();
              if (openDate == dateFormat) {
                aux = false;
              }
            });

            return aux;
          }
        },
      };
    },
    tiposCambio() {
      let cambio = this.$store.getters.getTiposCambios;
      return cambio[0];
    },
  },
  mounted() {
    this.showPrefered();
    //this.testRealTime();
  },
  beforeMount() {
    this.getClientes();
    this.MainDepartamento = localStorage.getItem("TopDepartment");
    if (this.isHotel) {
      this.prefered = true;
    }
    if (this.isWeb) {
      this.$store.commit("setTypePaid", 2);
    }

    if (!this.isWeb && !this.isHotel) {
      this.$store.commit("setTypePaid", 2);
      this.isAdmin = true;
    }

    this.$emit("useNav", true);
    this.$store.commit("setGlobalPrice", 190);
    this.init();
  },
  created() {
    setInterval(() => {
      let fecha = new moment();
      this.actualDate = fecha; //.format("YYYY-MM-DD HH:mm:ss");
    }, 1000);
  },
  watch: {
    // whenever question changes, this function will run
    players: function () {
      this.$forceUpdate();
    },
  },
};
</script>